import React from "react";
import { FaMagic, FaUserFriends, FaTags } from "react-icons/fa";

const chooseData = [
  {
    icon: <FaMagic size={24} className="text-white" />,
    title: "Quality and Innovation",
    description: "Top-quality thermocol with innovative designs and long-lasting durability."
  },
  {
    icon: <FaUserFriends size={24} className="text-white" />,
    title: "Customer-Centric Approach",
    description: "We prioritize customer satisfaction, offering personalized solutions for all needs."
  },
  {
    icon: <FaTags size={24} className="text-white" />,
    title: "Competitive Pricing",
    description: "Affordable prices for high-quality thermocol without compromising on performance."
  },
];


const Choose = () => {
  return (
    <div className="flax bg-blue_bg-100 md:pb-28 pb-14 pt-14 text-center">
      <div className="section-container">
      
      <div className="title-space">
        <div className="section-title">
        WHY CHOOSE US
      </div>
      <div className="title-description">
        Our Packaging services fulfill <br /> the standard of your product.
      </div>
      <div className="text-gray-600 max-w-3xl mx-auto mb-12">
      From electronics to food and fragile goods, our thermocol packaging ensures maximum safety and efficiency. We specialize in precision-engineered EPS packaging that ensures product safety, extends shelf life, and enhances your brand presentation — all while being cost-effective and eco-conscious. Combine advanced manufacturing with industry expertise.
      </div>
        </div>

      <div className="grid grid-cols-1 md:grid-cols-3 md:gap-8 gap-16">
        {chooseData.map((item, index) => (
          <div
            key={index}
            className={`relative bg-white px-6 pt-16 pb-10 min-h-[12rem] border border-dashed border-primary-200 rounded-sm transition-transform duration-300 hover:-translate-y-2 ${
              index === 1 ? "md:relative md:top-[3rem]" : ""
            }`}
            style={{
              boxShadow: "4px 4px 0px 0px #393184",
            }}
          >
            {/* Floating icon */}
            <div className="absolute top-[-30px] left-1/2 transform -translate-x-1/2 w-14 h-14 bg-primary-200 rounded-full flex items-center justify-center">
              {item.icon}
            </div>

            {/* Centered content */}
            <div className="flex flex-col items-center justify-center text-center h-full">
              <h3 className="text-lg font-semibold text-primary-100 mb-2">
                {item.title}
              </h3>
              <p className="text-gray-600 text-sm">{item.description}</p>
            </div>
          </div>
        ))}
      </div>
      </div>
    </div>
  );
};

export default Choose;
